const labels: Record<string, string> = {
  pending: "Aguardando aprovação",
  pending_submission: "Pedido recebido",
  pending_approval: "Em análise",
  awaiting_approval: "Aguardando aprovação",
  under_review: "Em análise",
  approved: "Aprovado",
  rejected: "Rejeitado",
  denied: "Negado",
  blocked: "Bloqueado",
  draft: "Rascunho",
  confirmed: "Confirmado",
  scheduled: "Programado",
  processing: "Em processamento",
  processed: "Processado",
  in_progress: "Em andamento",
  completed: "Concluído",
  finished: "Concluído",
  active: "Ativo",
  inactive: "Inativo",
  on_hold: "Em espera",
  released: "Liberado",
  ready: "Pronto",
  sent: "Enviado",
  failed: "Falha no envio",
  error: "Erro",
  cancelled: "Cancelado",
  canceled: "Cancelado",
  returned: "Devolvido",
  refunded: "Reembolsado",
  in_production: "Em produção",
  manufacturing: "Em produção",
  produced: "Produzido",
  shipped: "Enviado",
  dispatched: "Expedido",
  delivered: "Entregue",
  awaiting_shipment: "Aguardando expedição",
  ready_for_shipping: "Pronto para expedição",
  awaiting_delivery: "Aguardando entrega",
  billed: "Faturado",
  invoiced: "Faturado",
  partially_billed: "Faturado parcialmente",
  awaiting_billing: "Aguardando faturamento",
  pending_payment: "Aguardando pagamento",
  awaiting_payment: "Aguardando pagamento",
  partially_paid: "Pago parcialmente",
  paid: "Pago",
  received: "Recebido",
  settled: "Quitado",
  overdue: "Vencido",
  open: "Em aberto",
  authorized: "Autorizado",
  authorized_use: "Uso autorizado",
  unauthorized: "Não autorizado",
  voided: "Inutilizado",
  correction: "Carta de correção",
  faturado: "Faturado",
  em_producao: "Em produção",
  entregue: "Entregue",
  aprovado: "Aprovado",
  cancelado: "Cancelado",
  expedido: "Expedido",

  fabrication: "Fabricação",
  cutting: "Corte",
  machining: "Usinagem",
  stamping: "Estamparia",
  bending: "Dobra",
  welding: "Soldagem",
  galvanizing: "Zincagem",
  painting: "Pintura",
  finishing: "Acabamento",
  assembly: "Montagem",
  separation: "Separação",
  packaging: "Embalagem",
  quality_control: "Controle de qualidade",
  quality_inspection: "Inspeção de qualidade",
  awaiting_material: "Aguardando material",
  planning: "Planejamento",
  release: "Liberação",
  expedition: "Expedição",
  shipping: "Envio",
  delivery: "Entrega",

  boleto: "Boleto",
  bank_slip: "Boleto bancário",
  pix: "Pix",
  bank_transfer: "Transferência bancária",
  wire_transfer: "Transferência bancária",
  transfer: "Transferência bancária",
  credit_card: "Cartão de crédito",
  debit_card: "Cartão de débito",
  cash: "Dinheiro",
  check: "Cheque",
  cheque: "Cheque",
  bank_deposit: "Depósito bancário",
  deposit: "Depósito bancário",
  installment: "Parcelado",
  installments: "Parcelado",
  not_informed: "Não informado",
  unknown: "A definir",

  finished_product: "Produto acabado",
  final_product: "Produto final",
  raw_material: "Matéria-prima",
  component: "Componente",
  components: "Componentes",
  semi_finished: "Semiacabado",
  resale: "Revenda",

  invoice: "Fatura",
  sale_invoice: "Nota fiscal de venda",
  service_invoice: "Nota fiscal de serviço",
  billing: "Faturamento",
  sale: "Venda",
  order: "Pedido",
  production_order: "Ordem de produção"
};

const errorLabels: Record<string, string> = {
  "invalid credentials": "E-mail ou senha inválidos",
  "invalid email or password": "E-mail ou senha inválidos",
  "unauthorized": "Acesso não autorizado",
  "authentication required": "Autenticação necessária",
  "session expired": "Sua sessão expirou. Entre novamente.",
  "user not found": "Usuário não encontrado",
  "email already registered": "Este e-mail já está cadastrado",
  "company not found": "Empresa não encontrada",
  "customer not found": "Cliente não encontrado",
  "order not found": "Pedido não encontrado",
  "product not found": "Produto não encontrado",
  "not found": "Registro não encontrado",
  "forbidden": "Você não possui permissão para esta operação",
  "internal server error": "Erro interno do servidor",
  "failed to fetch": "Não foi possível conectar ao servidor",
  "network error": "Erro de conexão com o servidor",
  "request timeout": "A solicitação demorou demais. Tente novamente.",
  "jwt expired": "Sua sessão expirou. Entre novamente."
};

function normalize(value: string) {
  return value.trim().toLowerCase().replace(/[\s-]+/g, "_");
}

export function translateLabel(value?: string | null, fallback = "—") {
  if (!value) return fallback;
  const original = String(value).trim();
  const key = normalize(original);
  if (labels[key]) return labels[key];
  if (/^[A-Z]{2,}(?:-?e)?$/i.test(original) || /^\d/.test(original)) return original;
  return original.replace(/_/g, " ").replace(/\b\w/g, letter => letter.toLocaleUpperCase("pt-BR"));
}

export function translateProductionStage(value?: string | null) {
  return translateLabel(value);
}

export function translateCategory(value?: string | null, fallback = "Linha automotiva") {
  return translateLabel(value, fallback);
}

export function translateDocumentType(value?: string | null, fallback = "Documento") {
  if (!value) return fallback;
  const key = normalize(String(value));
  if (["nfe", "nf_e", "nf-e"].includes(key)) return "NF-e";
  if (key === "nfse" || key === "nfs_e") return "NFS-e";
  if (key === "danfe") return "DANFE";
  return translateLabel(value, fallback);
}

export function translateErrorMessage(message?: string | null) {
  if (!message) return "Não foi possível concluir a solicitação";
  const original = String(message).trim();
  const exact = errorLabels[original.toLowerCase()];
  if (exact) return exact;
  if (/network|fetch|connection/i.test(original)) return "Não foi possível conectar ao servidor";
  if (/timeout|timed out/i.test(original)) return "A solicitação demorou demais. Tente novamente.";
  return original;
}


export function translatePaymentStatus(value?: string | null) {
  if (!value) return "—";
  const key = normalize(String(value));
  const paymentLabels: Record<string, string> = {
    pending: "Pendente",
    pending_payment: "Aguardando pagamento",
    awaiting_payment: "Aguardando pagamento",
    open: "Em aberto",
    partially_paid: "Pago parcialmente",
    paid: "Pago",
    received: "Recebido",
    settled: "Quitado",
    overdue: "Vencido",
    cancelled: "Cancelado",
    canceled: "Cancelado",
    refunded: "Reembolsado"
  };
  return paymentLabels[key] || translateLabel(value);
}

export function translateFiscalStatus(value?: string | null) {
  if (!value) return "—";
  const key = normalize(String(value));
  const fiscalLabels: Record<string, string> = {
    pending: "Pendente",
    processing: "Em processamento",
    authorized: "Autorizada",
    authorized_use: "Autorizada",
    rejected: "Rejeitada",
    denied: "Denegada",
    cancelled: "Cancelada",
    canceled: "Cancelada",
    voided: "Inutilizada"
  };
  return fiscalLabels[key] || translateLabel(value);
}
